import {
  LOAD_BOOKING_KEY_CDAS,
  CREATE_BOOKING_KEY_CDAS,
  LOAD_BOOKING_KEY_CDAS_DETAIL,
  EXPORT_BOOKING_KEY_CDAS,
  REMOVE_LISTS,
} from './actions'
const initialState = {
  Lists: [],
  lists_for_edit: '',
  EditList: [],
  total: 1,
  loading: false,
  draw: -1,
  check: true,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState

    case LOAD_BOOKING_KEY_CDAS.REQUEST:
      const { loading } = action.payload.data
      return {
        ...state,
        loading: loading,
      }

    case LOAD_BOOKING_KEY_CDAS.SUCCESS:
      const { page } = action.payload
      for (let i = 0; i < action.payload.lists.data.length; i++) {
        action.payload.lists.data[i].rowNumber = i + 1
        if (page > 1)
          action.payload.lists.data[i].rowNumber =
            action.payload.lists.data[i].rowNumber + (page - 1) * 10
      }
      return {
        ...state,
        Lists: action.payload.lists.data,
        total:
          action.payload.lists.total - 1 <= 0
            ? 1
            : action.payload.lists.total <= 0
            ? 1
            : action.payload.lists.total,
        loading: false,
        draw: Math.floor(Math.random() * 999 + 1),
      }

    case LOAD_BOOKING_KEY_CDAS_DETAIL.REQUEST:
      return {
        ...state,
        loading: true,
        check: true,
      }

    case LOAD_BOOKING_KEY_CDAS_DETAIL.SUCCESS:
      return {
        ...state,
        loading: false,
        lists_for_edit: action.payload.listsEdit.data,
        check: false,
      }

    case EXPORT_BOOKING_KEY_CDAS.REQUEST:
      return {
        ...state,
        loading: true,
      }

    case EXPORT_BOOKING_KEY_CDAS.SUCCESS:
      return {
        ...state,
        loading: false,
      }

    default:
      return state
  }
}
